import { Button, message, Select } from "antd"
import Utils from "@utils/utils"
import { useContext, useState } from "react"
import styles from "./index.module.scss"
import PSAIModal from "@PSAIComponents/PSAIModal"
import API from '@api/api'
import { TRYON_CLOTH_TYPE, CLOTH_TYPE, UPLOAD_SOURCE, IMAGE_TYPE } from "@utils/CONST"
import { SEGMENT_ALGO_TYPE } from "@utils/CONST"
import CommodityDrag from "../CommodityDrag"
import { GenerateContext } from "../../../hooks/GenerateContext"
import { forwardRef, useImperativeHandle } from "react"
import UtilsAlgo from "@utils/utilsAlgo"
import UploadCard from "../UploadCard"
import Iconfont from '@utils/Iconfont';
import { UploadOutlined, RotateRightOutlined } from '@ant-design/icons';

const SingleUploader = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        sendUrlToInputImage: async (url, imageType) => {
            setLoading(true)
            try {
                const { width, height } = await Utils.getImageDimensions(url)
                if (imageType == IMAGE_TYPE.POSE_TRYON) {
                    const result = {
                        inputImage: url,
                        inputImageWidth: width,
                        inputImageHeight: height
                    }
                    await onChange(result)
                    return
                }
                const res2 = await processUrl(url, width, height)
                return res2
            } catch (err) {
                console.error(err)
                return false
            } finally {
                setLoading(false)
            }
        }
    }))

    const {
        // 图片url
        value,
        // 需要显示的图片url
        showValue = [],
        // 服装类型
        clothType,
        imageType,
        // 显示衣服类型
        showClothType = false,
        // 衣服类型检测
        clothTypeDetection = false,
        // 人体检测
        personDetection = false,
        // video tryon全身图片检测
        videoTryonImageDetection = false,
        // 检查图片比例不小于2:1
        imageRatioDetection = false,
        // 上传来源
        source,
        // 上传提示
        dragTips,
        // 上传按钮文字
        uploadText,
        // 内边距
        paddingInline = 25,
        // 抠图优化是否禁用
        mattingOptDisabled = false,
        // 位置调整是否禁用
        positionOptDisabled = true,
        // 位置调整参数
        positionOptValue,
        // 分割算法类型
        segmentAlgoType,
        // 分割算法类型（人体检测时）
        segmentAlgoTypeWhenPersonExist = SEGMENT_ALGO_TYPE.AIMODEL_MASK,
        // 上传成功回调
        onChange,
        // 抠图优化回调
        onMattingOpt,
        // 位置调整回调
        onPositionOpt,
        // 商品图位置调整回调
        onPositionChange,
        // 加载状态
        loading,
        // 加载状态回调
        setLoading,
        // 公众人物检测
        figureCheck = false,
        uploadIcon,
        showDeleteBtn = false,
        onDelete,
    } = props
    const {
        getClothMaskId,
        getShoesMaskId,
        getGlassesMaskId,
        getSimMaskId,
        getModelMaskId,
        getGoodsMaskId,
        getSemanticClothMaskId,
        getClothMaskOutput,
        getColorMaskOutput,
    } = useContext(GenerateContext)
    // 上传状态
    // const [loading, setLoading] = useState(false)
    // 违规图片重新上传
    const illegalAndReuploadHandle = async () => {
        return new Promise((resolve, reject) => {
            PSAIModal.confirm({
                content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                okText: '重新上传',
                cancelText: '取消',
                onOk() {
                    Utils.openFile().then((file) => {
                        if (file) {
                            uploadFile(file).then(resolve)
                        } else {
                            resolve(false)
                        }
                    }).catch(err => {
                        resolve(false)
                    })
                },
                onCancel() {
                    resolve(false)
                },
            })
        })
    }
    // 人物检测
    const personCheck = async (imageUrl) => {
        try {
            const res = await API.personCheck({
                imageUrl: imageUrl,
            })
            if (res.code != 0) throw new Error(res.message)
            return res.data
        } catch (err) {
            throw err
        }
    }
    // 上传文件
    const uploadFile = async (file) => {
        // 检查视频是否符合要求
        if (imageType == IMAGE_TYPE.MODEL_VIDEO || imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) {
            const validate = await Utils.validateImageFileToVideo(file)
            if (!validate) return false
        } else {
            const validate = await Utils.validateImageFile(file)
            if (!validate) return false
        }
        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ? 20000 : 4096)

        // 图片最大尺寸重置4096
        if (!resizeRes || !resizeRes.success) throw new Error(resizeRes?.message)
        file = resizeRes.file
        const inputImageWidth = resizeRes.width
        const inputImageHeight = resizeRes.height
        // 是否需要检查图片比例
        if (imageRatioDetection) {
            const aspectRatio = inputImageWidth / inputImageHeight;
            if (aspectRatio > 2 || aspectRatio < 0.5) throw new Error('图片比例不超过2:1')
        }
        // 检查上传图片是否符合安全规范
        const legalRes = await Utils.checkImageIslegal(file, 0, source, figureCheck) //审核
        if (!legalRes) return false
        if (!legalRes.isLegal) return await illegalAndReuploadHandle()
        const imageUrl = legalRes.data

        return {
            url: imageUrl,
            width: inputImageWidth,
            height: inputImageHeight,
        }
    }

    // 处理url 取显著性分割mask
    const processUrl = async (url, width, height) => {
        // const imageAntispamId = legalRes.imageAntispamId
        const imageUrl = url
        const inputImageWidth = width
        const inputImageHeight = height
        // 是否需要人体检测
        let isPerson = null
        if (personDetection) {
            isPerson = await personCheck(imageUrl)
        }
        // 是否需要vdieotryon检测
        if (videoTryonImageDetection) {
            const videoTryonRes = await Utils.videoTryonImageCheck(imageUrl, 1)
            if (videoTryonRes != 0) return
        }
        // 算法类型
        const _segmentAlgoType = (personDetection && isPerson) ? segmentAlgoTypeWhenPersonExist : segmentAlgoType
        // 是否需要服装类型检测
        let clothType = null
        if (clothTypeDetection) {
            // 衣物类型
            const _clothType = await UtilsAlgo.getClothType(imageUrl)
            // 服装类型 0-上装；1-下装；2-套装；3-裙装
            if ([CLOTH_TYPE.SHIRT, CLOTH_TYPE.SUIT].includes(_clothType)) clothType = TRYON_CLOTH_TYPE.TOP
            else if (_clothType == CLOTH_TYPE.PANTS) clothType = TRYON_CLOTH_TYPE.BOTTOM
            else if (_clothType == CLOTH_TYPE.DRESS) clothType = TRYON_CLOTH_TYPE.DRESS
        }
        // clothMaskId
        let clothMaskId = _segmentAlgoType == SEGMENT_ALGO_TYPE.AICLOTH_MASK ? await getClothMaskId(imageUrl) :
            _segmentAlgoType == SEGMENT_ALGO_TYPE.AISHOES_MASK ? await getShoesMaskId(imageUrl) :
                _segmentAlgoType == SEGMENT_ALGO_TYPE.AIGLASSES_MASK ? await getGlassesMaskId(imageUrl) :
                    _segmentAlgoType == SEGMENT_ALGO_TYPE.AISIM_MASK ? await getSimMaskId(imageUrl) :
                        _segmentAlgoType == SEGMENT_ALGO_TYPE.AIMODEL_MASK ? await getModelMaskId(imageUrl) :
                            _segmentAlgoType == SEGMENT_ALGO_TYPE.AIMODEL_BODY_MASK ? await getModelMaskId(imageUrl, true) :
                                _segmentAlgoType == SEGMENT_ALGO_TYPE.AIGOODS_MASK ? await getGoodsMaskId(imageUrl) :
                                    _segmentAlgoType == SEGMENT_ALGO_TYPE.SEMANTIC_CLOTH_MASK ? await getSemanticClothMaskId(imageUrl) :
                                        null
        let originalMask = null
        if (clothMaskId) {
            let editedMask = await getClothMaskOutput(clothMaskId)
            if (_segmentAlgoType == SEGMENT_ALGO_TYPE.SEMANTIC_CLOTH_MASK) {
                if (!editedMask.binaryMask) {
                    clothMaskId = await getShoesMaskId(imageUrl)
                    editedMask = await getClothMaskOutput(clothMaskId)
                } else {
                    const res = await Utils.getEditedMaskFromBinaryMask(editedMask.binaryMask, imageUrl)
                    editedMask.foregroundAlphaMask = res.foregroundAlphaMask
                    editedMask.foregroundMask = res.foregroundMask
                }
            }
            originalMask = editedMask
        }
        const result = {
            inputImage: imageUrl, // 图片url
            clothMaskId: clothMaskId, // 服装maskId
            originalMask,
            inputImageWidth,
            inputImageHeight,
        }
        if (clothTypeDetection) result.clothType = clothType
        if (personDetection) result.isPerson = isPerson
        await onChange(result)
        return
    }
    // 抠图优化
    const [mattingOptLoading, setMattingOptLoading] = useState(false)
    const handleMattingOpt = async (e) => {
        try {
            e.stopPropagation()
            setMattingOptLoading(true)
            await onMattingOpt()
        } catch (err) {
            console.error(err)
        } finally {
            setMattingOptLoading(false)
        }
    }
    // 位置优化
    const handlePositionOpt = async (e) => {
        try {
            e.stopPropagation()
            await onPositionOpt()
        } catch (err) {
            console.error(err)
        }
    }
    // 位置优化
    const handleDragChange = (res) => {
        onPositionChange(res)
    }
    // 上传图
    const handleUpload = async (file, fileList) => {
        try {
            const res = await uploadFile(file)
            if (!res) return
            if (source == UPLOAD_SOURCE.POSE_TRYON) {
                const result = {
                    inputImage: res.url,
                    inputImageWidth: res.width,
                    inputImageHeight: res.height
                }
                await onChange(result)
                return
            }
            const res2 = await processUrl(res.url, res.width, res.height)
            return res2
        } catch (err) {
            console.error(err)
            message.warning(err.message)
        }
    }


    return (
        <UploadCard
            dragTips={dragTips}
            paddingInline={paddingInline}
            disabled={mattingOptLoading}
            loading={loading}
            setLoading={setLoading}
            onUpload={handleUpload}
        >
            {
                value ?
                    <div className={styles.ContentAfterUpload} >
                        {
                            positionOptDisabled ?
                                <div className={`${styles.DisplayBox} ${showValue.length == 0 && styles.Loading}`}>
                                    {
                                        showValue?.map(item => (
                                            <img key={item} src={Utils.getImgThumbnail(item)} alt="" />
                                        ))
                                    }
                                </div> :
                                positionOptValue?.maskUrl ?
                                    <CommodityDrag
                                        key={value}
                                        readonly
                                        {...positionOptValue}
                                        onDragChange={handleDragChange}
                                    /> : null
                        }
                        <div className={styles.HoverToolsAfterUpload}>
                            <Button><UploadOutlined /> 重新上传</Button>
                            {showDeleteBtn && <Button onClick={(e) => {
                                e.stopPropagation()
                                onDelete()
                            }}><Iconfont type="icon-DeleteOutlined" /> 删除图片</Button>}
                            {
                                !mattingOptDisabled &&
                                <Button loading={mattingOptLoading} onClick={handleMattingOpt}>
                                    <Iconfont className={styles.Icon2} type="icon-pencil" />
                                    编辑选区
                                </Button>
                            } {
                                !positionOptDisabled &&
                                <Button onClick={handlePositionOpt}><RotateRightOutlined /> 位置优化</Button>
                            }
                        </div>
                        {showClothType && <Select
                            size="small"
                            value={clothType}
                            options={[
                                { label: '上装', value: TRYON_CLOTH_TYPE.TOP },
                                { label: '下装', value: TRYON_CLOTH_TYPE.BOTTOM },
                                { label: '连体装', value: TRYON_CLOTH_TYPE.DRESS },
                            ]}
                            onChange={(clothType) => onChange({ clothType })}
                            onClick={e => e.stopPropagation()}
                        />}
                    </div> :
                    <div className={styles.ContentBeforeUpload} >
                        {/* <Button loading={loading} type="primary">{uploadText}</Button> */}
                        <img src={"https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/" + uploadIcon} alt="" />
                        <span style={{ fontSize: 14 }}>{uploadText}</span>
                        <span>点击或将图片拖拽至区域</span>
                    </div>
            }
        </UploadCard>
    )
})

export default SingleUploader